export function getJwt() {
  return sessionStorage.getItem('token');
}

export function setJwt(value) {
  sessionStorage.setItem('token', value);
}

export function removeJwt() {
  sessionStorage.removeItem('token');
}

export function getReturnUrl() {
  return sessionStorage.getItem('returnUrl');
}

export function setReturnUrl(value) {
  sessionStorage.setItem('returnUrl', value);
}

export function removeReturnUrl() {
  sessionStorage.removeItem('returnUrl');
}
